import React, { Component, PureComponent } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper/index'
import { TableComp } from 'sz-react-utils'
// import GetAllFormFields from '../../../components/_utils/formUtils'
import { Button, Card, Form, Row, Col, Tooltip, DatePicker, Select, Drawer, notification, Popconfirm, Checkbox } from 'antd'
import _ from 'lodash'
import Request, { API_URL } from '../../request'
import { connect } from 'react-redux'
import moment from 'moment'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import userRights from '../../components/_utils/userRights'

const { MonthPicker } = DatePicker
const Option = Select.Option;
let userCheckBox = {};
let updationsData = {};
@Form.create()
class StaffSalaries extends PureComponent {
    state = {
        count: 0,
        defaultPageSize: 100,
        month: moment().subtract(1, 'month'),
        record: {},
        allUsers: [],
        userId: null,
        showResignationActionForm: false,
        detailDrawerVisible: false,
        exportLoading: false,
        exportParams: {},
        showSupportStaffSalaryDrawer: false,
        supportStaff: [],
        supportStaffSalary: {},
        userCheckBox:{},
        totals:{}
    }


    refreshFxn = () => {
        this.setState({ refreshChild: !this.state.refreshChild })
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    handleStaffLeaveApplication = (record) => {
        this.setState({ showResignationActionForm: true, record: record })
    }

    handleStaffLeaveApplicationClose = () => {
        this.setState({ showLeaveActionForm: false, record: {} })
        this.table.current.reload()
    }

    getSupportStaffSalary = async (staffId) => {
        let response = await Request.supportStaffSalaryById({ id: staffId })
        this.setState({ supportStaffSalary: response.doc })
        return response.doc
    }

    selectUser = (item, studentId) => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId]
          .isChecked;
        this.setState({ userCheckBox: cloneUserCheckBox });
      };
      selectAllUserFxn = () => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        _.each(cloneUserCheckBox, (item) => {
          item.isChecked = true;
        });
        this.setState({ userCheckBox: cloneUserCheckBox });
      };
      unselectAllUserFxn = () => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox);
        _.each(cloneUserCheckBox, (item) => {
          item.isChecked = false;
        });
        this.setState({ userCheckBox: cloneUserCheckBox });
      };


    apiRequest = params => {
        return new Promise(async (resolve) => {
            if (this.state.userId !== '') {
                params.userId = this.state.userId
            }
            params.sortField = 'name'
            params.sortOrder = 'ascend'
            params.deleted = false
            params.attendanceYearMonth = moment(this.state.month).format('YYYY-MM')
            let response = await Request.getStaffPayrolls(params)
            _.each(response.data, (item) => {
                if (!userCheckBox[item._id]) {
                  userCheckBox[item._id] = {
                    _id: item._id,
                    name: item.name,
                    attendanceYearMonth: item.attendanceYearMonth,
                    company: item.company,
                    isChecked: false,
                  };
                }
              });
            this.setState({ count: response.total, exportParams: params, userCheckBox:userCheckBox, totals:response.totals })
            resolve(response)
        })
    }

    exportExcel = async () => {
        const { exportParams } = this.state
        this.setState({ exportLoading: true })
        let x = await Request.exportStaffSalariesToExcel({ ...exportParams })
        this.setState({ exportLoading: false })

        if (!x.error) {
            window.open(x.url)
        }
    }

    addSupportStaffSalary = async () => {
        this.setState({ showSupportStaffSalaryDrawer: true })
    }

    handleMonthChange = (month, dateString) => {
        this.setState({ month: moment(month) }, () => {
            this.reload()
        })
    }


    handleDelete = async (recordId) => {
        let response = await Request.deleteSalaryRequest(recordId)
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: 'Something Went Wrong'
            })
        }
        this.reload()
    }

    async componentDidMount() {
        let params = {
            sortField: '_id',
            sortOrder: 'ascend',
            results: 200,
            isAdministrator: false,
            userType: { $ne: "Student" }
        };

        let response = await Request.loadUser({ ...params, regExFilters: ['name'] })
        let userArray = [];
        response.data.map((user, index) => {
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        let supportStaffReport = await Request.getSupportStaffSalary()
        let supportStaff = []
        supportStaffReport.data.map((user, index) => {
            supportStaff.push({
                _id: user._id,
                display: user.name
            })
            userArray.push({
                _id: user._id,
                display: user.name
            })
        })
        this.setState({ allUsers: userArray, supportStaff: supportStaff })
    }

    closeDetailDrawer = () => {
        this.setState({ detailDrawerVisible: false })
    }

    markSalaryPaid = async() => {
        let userArr = _.filter(this.state.userCheckBox, (item) => {
          return item.isChecked;
        }); 
        if (userArr && userArr.length) {
          updationsData = {
            usersData: userArr,
          };
          let response = await Request.updateStaffSalaryPayment(updationsData)
          if(response.success) {
            notification.success({
                message:response.message
            })
            this.unselectAllUserFxn()
          }else {
            notification.error({
                message:response.message
            })
            this.unselectAllUserFxn()
          }
          this.reload()
        } else {
          notification.error({
            message: "Please select atleast 1 user.",
          });
        }
      };

    handleSupportStaffSalarySubmission = (e) => {
        const { form, dispatch } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            let { supportStaffSalary } = this.state
            let values = _.clone(valData)
            values.joiningSalary = supportStaffSalary.joiningSalary
            values.name = supportStaffSalary.name
            values.fatherName = supportStaffSalary.fatherName
            values.company = supportStaffSalary.company
            let response = await Request.addSupportStaffSalaryConfirmation(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            // form.resetFields()
            this.props.form.setFieldsValue({ userId: '', staffSalary: '', workingDays: '', attendanceYearMonth: '', confirmationStatus: '' })
            this.reload()
            this.setState({ showSupportStaffSalaryDrawer: false, supportStaffSalary: {} })
        })
    }

    reload = () => {
        this.table.current.reload();
    };

    render() {
        let { form: { setFieldsValue, getFieldDecorator } } = this.props
        const { defaultPageSize, count, allUsers, showSupportStaffSalaryDrawer, supportStaff, supportStaffSalary } = this.state
        let supportStaffInput = {
            fields: [
                {
                    label: 'Select User',
                    key: 'userId',
                    type: 'select',
                    options: supportStaff,
                    required: true,
                    onChange: async (v) => {
                        setFieldsValue({ userId: v })
                        let response = await this.getSupportStaffSalary(v)
                        setFieldsValue({ staffSalary: response.staffSalary })
                    }
                },
                {
                    label: 'Staff Salary',
                    type: 'number',
                    key: 'staffSalary',
                    required: true
                },
                {
                    label: 'Staff Working Days',
                    type: 'number',
                    key: 'workingDays',
                    required: true
                },
                {
                    label: 'Salary Month',
                    type: "date",
                    required: true,
                    key: 'attendanceYearMonth'
                },
                {
                    label: 'Status',
                    type: 'select',
                    key: 'confirmationStatus',
                    required: true,
                    options: ['Pending', 'Approved'],
                    onChange: v => {
                        setFieldsValue({ confirmationStatus: v })
                    }
                }
            ]
        }
        const totalColumns = [
            {
                title: 'Salary (Before EPF Deductions)',
                key: 'totals.salaryBeforeDeduct',
                render: (text, record) => (
                    <div>
                        <span>{this.state.totals.salaryBeforeDeduct?this.state.totals.salaryBeforeDeduct.toFixed():0}</span>
                    </div>
                )
            },
            {
                title: 'EPF',
                key: 'total.totalEPF',
                render: (text, record) => (
                    <div>
                        {this.state.totals.totalEPF?this.state.totals.totalEPF.toFixed():0}
                    </div>
                )
            },
            {
                title: 'ESIC',
                key: 'totals.totalESIC',
                render: (text, record) => (
                    <div>
                        {this.state.totals.totalESIC? this.state.totals.totalESIC.toFixed() : 0}
                    </div>
                )
            },
            {
                title: 'CTC Deduction',
                key: 'totals.totalCtcDeduct',
                render: (text, record) => (
                    <div>
                        {this.state.totals.totalCtcDeduct? this.state.totals.totalCtcDeduct.toFixed() : 0}
                    </div>
                )
            },
            {
                title: 'Take Home Salary',
                key: 'totals.totalTakeHomeSalary',
                render: (text, record) => (
                    <div>
                        {this.state.totals.totalTakeHomeSalary? this.state.totals.totalTakeHomeSalary.toFixed() : 0}
                    </div>
                )
            },
        ]
        const columns = [
            
            {
                title: 'S No.',
                key: 'serialNumber',
                width: 60,
                fixed: true,
                render: (text, record, index) => {
                    return (
                        <span>{index + 1}</span>
                    )
                }
            },
            {
                title:'Payment Status',
                key:'paymentStatus',
                width:100,
                render:(text, record)=>{
                    if(record.paymentStatus === "Paid") {
                        return (
                            <div style={{backgroundColor:"green", color:"white"}}>{text}</div>
                        )
                    }else {
                        return (
                            <div>{text}</div>
                        )
                    }
                }
            },
            {
                title: 'Employee Name',
                key: 'userId.name',
                width: 150,
                render: (text, record) => (
                    <span>{record.userId ? record.userId.name : record.name}</span>
                )
            },
            {
                title:'Company',
                key:'company'
            },
            {
                title: 'Basic Salary',
                key: 'userId.salary',
                width: 120,
                render: (text, record) => (
                    <span>{record.userId ? record.userId.salary : record.staffSalary}</span>
                )
            },
            {
                title: 'Per Day Salary',
                key: 'perDaySalary',
                render: (text, record) => (
                    <span>{record.userId ? (record.userId.salary / record.totalWorkingDays).toFixed() : parseFloat(record.perDaySalary).toFixed()}</span>
                )
            },
            {
                title: 'Father Name',
                key: 'userId.fatherName',
                render: (text, record) => (
                    <span>{record.userId ? record.userId.fatherName : record.fatherName}</span>
                )
            },
            {
                title: 'Month',
                key: 'attendanceYearMonth',
                render: (text, record) => (
                    <div>{moment(text, 'YYYY-MM').format('MMMM-YYYY')}</div>
                )
            },
            {
                title: 'Total Worked Hours',
                key: 'totalHours',
                render: (text, record) => (
                    <div>{record.totalWorkedHours && record.extraHours?(record.totalWorkedHours - record.extraHours).toFixed(2):"NA"}</div>
                )
            },
            {
                title: 'Weekly Off + Paid Leaves',
                key: 'extraHours',

            },
            {
                title: 'Leave Hours / Days',
                key: 'hourDeduction',
                render: (text, record) => (
                    <div>
                        <span>{record.hourDeduction ? record.hourDeduction + '/' + (record.hourDeduction / record.allowedWorkingHours) : "NA"}</span>
                    </div>
                )
            },
            {
                title: 'Total Hours',
                key: 'totalWorkedHours',
                render: (text, record) => (
                    <div>
                        <span>{record.totalWorkedHours ? record.totalWorkedHours.toFixed(2) : "NA"}</span>
                    </div>
                )
            },
            {
                title: 'Total Days',
                key: 'totalWorkedDays',
                render: (text, record) => (
                    <div>
                        <span>{record.totalWorkedHours ? (record.totalWorkedHours / record.allowedWorkingHours).toFixed(1) : record.totalWorkedDays}</span>
                    </div>
                )
            },
            {
                title: 'Salary (Before EPF Deductions)',
                key: 'totalSalary',
                width: 150,
                render: (text, record) => (
                    <div>
                        <span>{record.totalSalary ? record.totalSalary.toFixed() : "NA"}</span>
                    </div>
                )
            },
            {
                title: 'EPF',
                key: 'epf',
                render: (text, record) => (
                    <div>
                        {record.epf > 0 ? record.epf.toFixed() : 0}
                    </div>
                )
            },
            {
                title: 'ESIC',
                key: 'esic',
                render: (text, record) => (
                    <div>
                        {record.esic > 0 ? record.esic.toFixed() : 0}
                    </div>
                )
            },
            {
                title: 'CTC Deduction',
                key: 'uanDeduction',
                render: (text, record) => {
                    if (record.uanNumber && record.staffSalary > 21000 || record.uanNumber && record.staffSalary > 15000 && record.staffSalary <= 21000) {
                        this.setState({ uanDeduction: record.totalSalary * 25 / 100 })
                        return (
                            record.totalSalary * 25 / 100
                        )
                    }
                }
            },
            {
                title: 'Take Home Salary',
                key: 'inHandSalary',
                render: (text, record) => {
                    if (!record.uanNumber) {
                        return (
                            <div>{(record.totalSalary - record.epf - record.esic).toFixed()}</div>
                        )
                    } else if (record.uanNumber && record.staffSalary > 21000) {
                        return (
                            <div>{record.totalSalary - (record.totalSalary * 25 / 100).toFixed()}</div>
                        )
                    }
                }
            },
            {
                title: 'Comment',
                key: 'comment'
            },
            {
                title: 'Status',
                key: 'confirmationStatus',
                render: (text, record) => {
                    if (text === "Approved") {
                        return (
                            <div style={{ background: 'green', color: 'white' }}>{text}</div>
                        )
                    } else if (text === "Disapproved") {
                        return (
                            <div style={{ background: 'red' }}>{text}</div>
                        )
                    } else {
                        return (
                            <div style={{ background: 'yellow' }}>{text}</div>
                        )
                    }
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => {
                    return (
                    <div>
                        <span>
                        <Checkbox
                            checked={
                            userCheckBox[record._id]
                                ? userCheckBox[record._id].isChecked
                                : false
                            }
                            onChange={(y) => {
                            this.selectUser(y, record._id);
                            }}
                        />
                        </span>
                    
                        <Tooltip title="Delete Request">
                            <Popconfirm
                                title="Are you sure to delete?"
                                onConfirm={() => this.handleDelete(record._id)}>
                                <Button
                                    size={"small"}
                                    shape="circle"
                                    icon="cross"
                                />
                            </Popconfirm>
                        </Tooltip>
                        </div>
                    )
                }
            }

            // {
            //     title:'Action',
            //     key:'operation',
            //     dataindex: "operation",
            //     render: (text, record) => (
            //         <RightsWrapper myRight={'StaffLeaves.edit'}>
            //         <React.Fragment>
            //         <Tooltip title="Action">
            //           <Button
            //             size={"small"}
            //             shape="circle"
            //             onClick={() => this.handleStaffLeaveApplication(record)}
            //             icon="forward"
            //           />
            //         </Tooltip>&nbsp;
            //         <Tooltip title="View Details">
            //                 <Button
            //                     size={'small'}
            //                     shape="circle"
            //                     icon='eye'
            //                     onClick={() => {
            //                         this.setState({
            //                             record: record,
            //                             detailDrawerVisible: true
            //                         })
            //                     }}
            //                 ></Button>
            //             </Tooltip>
            //       </React.Fragment>
            //       </RightsWrapper>
            //     ),
            // }
        ]


        return (
            <PageHeaderWrapper title={`Staff Salaries:- ${count}`}>
                <Card bordered={true}>
                    <Row>
                        <Col span={4}>
                            <label>Search By Month</label>
                            <MonthPicker placeholder='Select Month' defaultValue={moment(this.state.month, 'YYYY-DD')} format="YYYY-MM" onChange={this.handleMonthChange} />
                        </Col>
                        <Col span={6}>
                            <label>Search by User</label>
                            <Select
                                allowClear
                                showSearch={true}
                                style={{ width: '90%' }}
                                value={this.state.userId}
                                placeholder="Select Option"
                                optionFilterProp="name"
                                onChange={userId => {
                                    this.setState(
                                        {
                                            userId: userId && userId.toString()
                                        },
                                        () => {
                                            setTimeout(() => {
                                                this.reload()
                                            }, 500);
                                        }
                                    );
                                }}
                                filterOption={(input, option) => {
                                    return (
                                        option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                    );
                                }}
                            >
                                {
                                    allUsers.map((val, idn) => {
                                        return (
                                            <Option key={idn} value={val._id}>{val.display}</Option>
                                        )
                                    })
                                }

                            </Select>
                        </Col>
                        <Col span={3}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                {
                                    userRights.checkRights("StaffSalariesExcelExport.view") ?
                                        <Button type={'default'}
                                            loading={this.state.exportLoading}
                                            onClick={() => {
                                                this.exportExcel()
                                            }}>Export Excel</Button>
                                        : null
                                }
                            </div>
                        </Col>
                        <Col span={3}>
                            <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Button type={'default'}
                                    loading={this.state.exportLoading}
                                    onClick={() => {
                                        this.addSupportStaffSalary()
                                        // this.exportExcel()
                                    }}>Add</Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <Row>
                    <Col span={3}>
                        <div>
                            <Button
                                onClick={() => this.selectAllUserFxn()}
                            >
                                Select Visible
                            </Button>
                        </div>
                    </Col>
                    <Col span={3}>
                                <Button
                                onClick={() => this.unselectAllUserFxn()}
                            >
                                Unselect Visible
                            </Button>
                    </Col>
                    <Col span={3}>
                            <Button
                                onClick={() => this.markSalaryPaid()}
                            >
                                Mark Paid
                            </Button>
                    </Col>
                    </Row>
                </Card>
                <Card bordered={true} >
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1800 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: defaultPageSize,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                    <h3>Totals:-</h3>
                    <table style={{width: '100%', textAlign:'center'}}>
                        <thead>
                            <tr>
                                <th>Basic Salary</th>
                                <th>Salary Before Deductions</th>
                                <th>Total EPF</th>
                                <th>Total ESIC</th>
                                {/* <th>Total CTC Deduction</th> */}
                                <th>Total Take Home Salary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{this.state.totals && this.state.totals.totalBasicSalary?this.state.totals.totalBasicSalary.toFixed():0}</td>
                                <td>{this.state.totals && this.state.totals.salaryBeforeDeduct?this.state.totals.salaryBeforeDeduct.toFixed():0}</td>
                                <td>{this.state.totals && this.state.totals.totalEPF?this.state.totals.totalEPF.toFixed():0}</td>
                                <td>{this.state.totals && this.state.totals.totalESIC?this.state.totals.totalESIC.toFixed():0}</td>
                                {/* <td>{this.state.totals && this.state.totals.totalCtcDeduct?this.state.totals.totalCtcDeduct.toFixed():0}</td> */}
                                <td>{this.state.totals && this.state.totals.totalTakeHomeSalary?this.state.totals.totalTakeHomeSalary.toFixed():0}</td>
                            </tr>
                        </tbody>
                    </table>
                    {/* <TableComp
                        ref={this.table}
                        columns={totalColumns}
                    /> */}
                </Card>
                <Drawer
                    title="Add Support Staff Salary"
                    placement="right"
                    closable={true}
                    visible={showSupportStaffSalaryDrawer}
                    width={500}
                    onClose={() => {
                        this.setState({
                            showSupportStaffSalaryDrawer: false
                        })
                    }}>
                    <Form onSubmit={this.handleSupportStaffSalarySubmission}>
                        <Card>
                            <GetAllFormFields
                                inputSchema={supportStaffInput}
                                getFieldDecorator={getFieldDecorator} />
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{ marginBottom: 10, marginLeft: '33%' }}
                                loading={this.props.loading}>
                                SAVE
                            </Button>
                        </Card>
                    </Form>
                </Drawer>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffSalaries)
